/* eslint-disable import/prefer-default-export */
export const SET_START_TIME = 'SET_START_TIME';
